import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import DialogContentText from '@mui/material/DialogContentText';
import { CargoShipmentFeeManagement } from '../../Cargo.helper';
import Swal from 'sweetalert2';
import { CargoCommand } from '../../../../services/command';
import { Box, Fade, LinearProgress } from '@mui/material';
import { CSF } from '../../cargoShippingFeeManagement.classes';
import {
    applyShippingFeeRowChanges,
    buildShippingFeeUpdatePayload,
    isNumericValue,
} from '../../CargoShippingFeeManagement.helper';

interface IProps {
    selectedRow?: any;
    open?: boolean;
    onClose?: any;
    dialogContent?: string;
    dialogTitle?: string;
    buttonNameAccept?: string;
    buttonNameReject?: string;
    closeEditModal?: any;
    setDatas?: any;
    datas?: CargoShipmentFeeManagement[];
    uploadDatas: any[];
    setUploadDatas: any;
    actionType?: 'update' | 'delete' | 'fileUpload';
    updatedRow?: any;
    filterInput?: any;
    getCargoShipmentList?: any;
}

export const SCUIConfirmDialog: FC<IProps> = ({
    selectedRow,
    dialogContent,
    dialogTitle,
    buttonNameAccept,
    buttonNameReject,
    open = false,
    onClose,
    closeEditModal,
    actionType,
    setDatas,
    datas,
    updatedRow,
    uploadDatas,
    setUploadDatas,
    filterInput,
    getCargoShipmentList,
}) => {
    const { t } = useTranslation();
    const [loading, setLoading] = React.useState<any>(false);
    const regionId: any = JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.regionId;

    const isNumeric = isNumericValue;

    const handleClose = () => {
        onClose(false);
    };
    const UpdateCargoShipmentRuleItem = async () => {
        try {
            if (!loading) {
                setLoading(true);
                if (updatedRow && selectedRow) {
                    if (updatedRow.id === selectedRow.id) {
                        if (!isNumeric(updatedRow.shipmentFee) || !isNumeric(updatedRow.shoppingAmount)) {
                            Swal.fire('Error', t('general.checkShipmentFee'), 'error');
                            handleClose();
                            return;
                        }

                        const { selectedRowCopy, isChange } = applyShippingFeeRowChanges(selectedRow, updatedRow);

                        if (isChange) {
                            const updateId: number = selectedRowCopy.id;
                            const updateData = buildShippingFeeUpdatePayload(selectedRowCopy, regionId);

                            let response = await CargoCommand.UpdateShippingFeeManagement(updateData);

                            if (response.isSuccess) {
                                selectedRowCopy.id = response.data[0];
                                updateObjectArray(datas!, selectedRowCopy, updateId);
                                Swal.fire('Success', t('general.updateOperationSuccessMessage'), 'success');
                            } else {
                                Swal.fire(
                                    'Service Error - StatusCode : ' + response.statusCode,
                                    'Error Message : ' + response.errorMessage,
                                    'error'
                                );
                            }
                        } else {
                            Swal.fire('Error', t('general.noChangeFound'), 'warning');
                        }
                    }
                } else {
                    Swal.fire('No Data Found', t('general.noDataFound'), 'error');
                }
                setLoading(false);
            }
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
            setLoading(false);
        }
        closeEditModal();
        handleClose();
    };
    const updateObjectArray = async (arr: any[], updatedObject: any, updateId: number) => {
        try {
            const arrCopy = Array.from(arr);
            const objWithIdIndex = arrCopy.findIndex((obj) => obj.id === updateId);
            if (objWithIdIndex > -1) {
                arrCopy[objWithIdIndex] = updatedObject;
            }
            setDatas(arrCopy);
        } catch (error: any) {
            Swal.fire(error?.data?.Message, error?.data?.Key, 'error');
        }
    };
    const DeleteCargoShipmentRuleItem = async () => {
        try {
            if (!loading) {
                setLoading(true);
                if (selectedRow) {
                    let response = await CargoCommand.DeleteShippingFeeManagement(selectedRow.toString());

                    if (response.isSuccess) {
                        removeObjectWithId(datas!, selectedRow);
                        Swal.fire('Success', t('general.deleteOperationSuccessMessage'), 'success');
                    }
                } else {
                    Swal.fire('No Data Found', t('general.noDataFound'), 'error');
                }
                setLoading(false);
            }
        } catch (error: any) {
            Swal.fire(error?.data?.Message, error?.data?.Key, 'error');
            setLoading(false);
        }
        handleClose();
    };
    const removeObjectWithId = async (arr: any[], id: number) => {
        try {
            const arrCopy = Array.from(arr);
            const objWithIdIndex = arrCopy.findIndex((obj) => obj.id === id);

            if (objWithIdIndex > -1) {
                arrCopy.splice(objWithIdIndex, 1);
            }
            setDatas(arrCopy);
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };
    const UploadExcelDatas = async () => {
        try {
            if (!loading) {
                setLoading(true);
                if (uploadDatas) {
                    let apiData: any[] = [];

                    uploadDatas.forEach((s) => {
                        let addData: any = {
                            regionId: regionId,
                            ruleKey: 'ShippingFeeManagement',
                            tenant: 9,
                            action: s.shipmentFee?.toString(),
                            ruleTemplateId: s.ruleTemplateId,
                        };
                        if (s.id !== undefined) {
                            addData.id = s.id;
                        }

                        let criterias: any[] = [];
                        if (s.shoppingAmount != null && s.shoppingAmount >= 0) {
                            criterias.push({
                                key: 'shoppingAmount',
                                operator: 3,
                                value:
                                    s.condition === '<'
                                        ? '0#' + s.shoppingAmount?.toString()
                                        : s.shoppingAmount?.toString() + '#',
                            });
                        }
                        if (s.deliveryTypeId != null && s.deliveryTypeId >= 0) {
                            criterias.push({
                                key: 'DeliveryType',
                                operator: 0,
                                value: s.deliveryTypeId?.toString(),
                            });
                        }
                        if (s.regionId != null && s.regionId >= 0) {
                            criterias.push({
                                key: 'region',
                                operator: 0,
                                value: s.regionId?.toString(),
                            });
                        }
                        if (s.cargoCompanyId != null && s.cargoCompanyId >= 0) {
                            criterias.push({
                                key: 'ShippingCompanyId',
                                operator: 0,
                                value: s.cargoCompanyId?.toString(),
                            });
                        }
                        addData.criteria = criterias;
                        apiData.push(addData);
                    });

                    let request: any = { rules: apiData };

                    let response = await CargoCommand.AddShippingFeeManagement(request);
                    if (response.isSuccess) {
                        getCargoShipmentList(filterInput);
                        Swal.fire('Success', t('general.updateOperationSuccessMessage'), 'success');
                    } else {
                        Swal.fire(
                            'Service Error - StatusCode : ' + response.statusCode,
                            'Error Message : ' + response.errorMessage,
                            'error'
                        );
                    }
                } else {
                    Swal.fire('No Data Found', t('general.updateOperationSuccessMessage'), 'error');
                }
                setUploadDatas([]);
                handleClose();
                setLoading(false);
            }
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
            setLoading(false);
        }
    };
    const confirmAcceptHandle = async () => {
        try {
            if (actionType === 'delete') {
                DeleteCargoShipmentRuleItem();
            } else if (actionType === 'update') {
                UpdateCargoShipmentRuleItem();
            } else {
                UploadExcelDatas();
            }
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };
    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className={CSF.confirmDialog}
                data-action-type={actionType}
            >
                <Box className={CSF.confirmDialogLoading}>
                    <Fade in={loading} unmountOnExit>
                        <LinearProgress />
                    </Fade>
                </Box>
                {dialogTitle && dialogTitle != '' ? (
                    <DialogTitle className={CSF.confirmDialogTitle}>{dialogTitle}</DialogTitle>
                ) : (
                    <div style={{ display: 'none' }}></div>
                )}
                <DialogContent className={CSF.confirmDialogContent}>
                    <DialogContentText
                        id="alert-dialog-description"
                        className={CSF.confirmDialogContentText}
                    >
                        {dialogContent}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={CSF.confirmDialogActions}>
                    <Button
                        onClick={onClose}
                        className={CSF.btnConfirmReject}
                        data-action-type={actionType}
                    >
                        {buttonNameReject}
                    </Button>
                    <Button
                        onClick={confirmAcceptHandle}
                        autoFocus
                        className={CSF.btnConfirmAccept}
                        data-action-type={actionType}
                    >
                        {buttonNameAccept}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};
